module.exports = __webpack_public_path__ + "img/subscription.df00a569.png";